var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "setting-wrapper"
  }, [_c('h3', [_vm._v("Settings")]), _c('div', {
    staticClass: "setting-container d-flex"
  }, [_vm._m(0), _c('div', {
    staticClass: "setting-wrap"
  }, [_c('div', {
    staticClass: "personal-info detail-card mb-4",
    attrs: {
      "id": "notify-info"
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "pad-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-lg-6 col-md-12"
  }, [_c('p', {
    staticClass: "mb-1 info-title"
  }, [_vm._v("Email notification")]), _c('div', {
    staticClass: "mb-2 info-light"
  }, [_vm._v(" Get email to find what’s going on and what you are missing when you are offline. You can turn the following on and off: ")]), _c('div', {
    staticClass: "category-filter"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedCategoryId,
      expression: "selectedCategoryId"
    }],
    staticClass: "univ-input mb-3",
    attrs: {
      "disabled": _vm.loadingCategories
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onCategoryChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("Select Category")]), _vm._l(_vm.categories, function (category) {
    return _c('option', {
      key: category.id,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  })], 2), _vm.loadingCategories ? _c('div', {
    staticClass: "text-center mb-3"
  }, [_vm._m(2), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Loading categories...")])]) : _vm._e(), _vm.selectedCategory ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center flex-wrap"
  }, [_c('div', {}, [_c('b', [_vm._v(_vm._s(_vm.selectedCategory.name))])]), _c('div', {
    staticClass: "form-check form-switch-parent m-0 p-0"
  }, [_c('label', {
    staticClass: "switch m-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedCategory.enabled,
      expression: "selectedCategory.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.updatingCategoryStatus
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedCategory.enabled) ? _vm._i(_vm.selectedCategory.enabled, null) > -1 : _vm.selectedCategory.enabled
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.selectedCategory.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.selectedCategory, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.selectedCategory, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.selectedCategory, "enabled", $$c);
        }
      }, _vm.updateCategoryStatus]
    }
  }), _c('span', {
    staticClass: "slider round slider-parent"
  })])])]) : _vm._e(), _vm.selectedCategory ? _c('hr', {
    staticClass: "mt-2"
  }) : _vm._e(), _vm.updatingCategoryStatus ? _c('div', {
    staticClass: "text-center mb-3"
  }, [_vm._m(3), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Updating category status...")])]) : _vm._e(), _vm.loadingSubCategories ? _c('div', {
    staticClass: "text-center"
  }, [_vm._m(4), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Loading subcategories...")])]) : _vm.selectedCategory ? _c('div', {
    staticClass: "category-list"
  }, [_vm._l(_vm.subCategories, function (subCategory) {
    return _c('div', {
      key: subCategory.id,
      staticClass: "d-flex gap-3 mb-3"
    }, [_c('div', {
      staticClass: "form-check form-switch m-0 p-0"
    }, [_c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: subCategory.enabled,
        expression: "subCategory.enabled"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.updatingSubCategoryStatus
      },
      domProps: {
        "checked": Array.isArray(subCategory.enabled) ? _vm._i(subCategory.enabled, null) > -1 : subCategory.enabled
      },
      on: {
        "change": [function ($event) {
          var $$a = subCategory.enabled,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(subCategory, "enabled", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(subCategory, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(subCategory, "enabled", $$c);
          }
        }, function ($event) {
          return _vm.updateSubCategoryStatus(subCategory);
        }]
      }
    }), _c('span', {
      staticClass: "slider round"
    })])]), _c('div', [_c('h3', {
      staticClass: "h6 mb-1"
    }, [_vm._v(_vm._s(subCategory.name))]), _c('p', {
      staticClass: "text-muted mb-0 f-14"
    }, [_vm._v(" " + _vm._s(subCategory.label || 'No description available') + " ")])])]);
  }), !_vm.loadingSubCategories && _vm.subCategories.length === 0 ? _c('div', {
    staticClass: "text-center text-muted py-3"
  }, [_vm._v(" No subcategories available for this category ")]) : _vm._e()], 2) : _vm._e()])])])])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('ul', {
    staticClass: "side-section-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#notify-info"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bell-icon.svg")
    }
  }), _vm._v("Notifications ")])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "title-head"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Notification")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading categories...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Updating...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);

}]

export { render, staticRenderFns }